import { HttpBackend, HttpClient, HttpResponse } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
@Pipe({
  name: 'iconSource',
})
export class IconSourcePipe implements PipeTransform {
  constructor(
    private httpBackend: HttpBackend,
    private domSanitizer: DomSanitizer) {}
  transform(value: any, ...args: any[]): any {
    if (isNullOrEmpty(value)) {
      return of(value);
    }
    const httpClient = new HttpClient(this.httpBackend);
    const observable = httpClient
      .get(value, { observe: 'response', responseType: 'blob' })
      .pipe(
        map((response: HttpResponse<Blob>) => {
          if (response.status === 404) {
            return './assets/images/ic-apply.svg';
          } else {
            return this.domSanitizer.bypassSecurityTrustUrl(
              URL.createObjectURL(response.body!)
            );
          }
        }),
        catchError((err) => {
          return of('./assets/images/ic-apply.svg');
        })
      );
    return observable;
  }
}
